import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import Switch from 'react-switch';

import { FormLabel, ToggleContainer } from '../../css';

const AccessToggle = ({ data, formsControl, setFormsControl }) => {
  const { key, label } = data;
  const isEnabled = !_.get(formsControl, key, false);

  return (
    <ToggleContainer isEnabled={isEnabled}>
      <FormLabel isEnabled={isEnabled}>{label}</FormLabel>
      <Switch
        onColor="#4B286D"
        onChange={() =>
          setFormsControl({
            ...formsControl,
            [key]: !_.get(formsControl, key, false)
          })
        }
        checked={isEnabled}
      />
    </ToggleContainer>
  );
};

AccessToggle.propTypes = {
  data: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string
  }).isRequired,
  formsControl: PropTypes.shape(PropTypes.object).isRequired,
  setFormsControl: PropTypes.func.isRequired
};

export default AccessToggle;
